import styled from 'styled-components'

export const ContainerGaveta = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  h2 {
    font-size: 18px;
    font-weight: 700;
    padding: 0;
    margin: 0;
    color: #2d3436;
  }

  .informacoes__perfil {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;

    .img__perfil {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 10px;

      h3 {
        padding: 0;
        margin: 0;
        font-size: 16px;
        text-transform: capitalize;
        font-weight: 600;
        color: #2d3436;
      }

      img {
        border-radius: 50%;
        width: 35%;
      }
    }

    .dados__aniversariantes {
      width: 100%;
      display: flex;
      gap: 10px;

      .idade__empresa {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        padding: 10px;
        border-radius: 10px;

        p {
          font-size: 13px;
          padding: 0;
          margin: 0;
          color: #2d3436;
          display: flex;
          gap: 5px;
        }
      }
    }
  }
`